import axios from "axios";

export const getMeetingList = async (baseUrl, token, trainerId, projectId) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let getResponse = null;

  await axios
    .get(baseUrl + "/meeting/" + trainerId + "/" + projectId, config)
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};

export const getMeeting = async (baseUrl, token, meetingId) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let getResponse = null;

  await axios
    .get(baseUrl + "/meeting/" + meetingId, config)
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};

export const meetingCheck = async (baseUrl, token, url) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let getResponse = null;

  await axios
    .get(baseUrl + "/meeting/check/" + url, config)
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};

export const startParticipant = async (baseUrl, participantId) => {
	let putResponse = null;

	await axios
		.put(baseUrl + "/meeting/participant/start/" + participantId)
		.then((res) => {
			putResponse = {
				status: res.data.status,
				data: res.data,
			};
		})
		.catch((error) => {
			if (error.response !== undefined) {
				putResponse = {
					status: error.response.status,
					data: error.response.status,
				};
			}
		});
	return putResponse;
};

export const upsertMeeting = async (
  baseUrl,
  token,
  trainerId,
  meeting,
  participant = false
) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let postResponse = null;

  await axios
    .post(
      baseUrl +
        "/meeting/" +
        trainerId +
        "/meeting" +
        (participant ? "/participant" : ""),
      meeting,
      config
    )
    .then((res) => {
      postResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        postResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return postResponse;
};

export const inviteMeeting = async (baseUrl, token, trainerId, invite) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let postResponse = null;

  await axios
    .post(baseUrl + "/meeting/" + trainerId + "/meeting-invite", invite, config)
    .then((res) => {
      postResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        postResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return postResponse;
};

export const changeMeetingStatus = async (
  baseUrl,
  token,
  trainerId,
  meetingId,
  status
) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let putResponse = null;

  await axios
    .put(
      baseUrl +
        "/meeting/" +
        trainerId +
        "/meeting/" +
        meetingId +
        "/status/" +
        status,
      {},
      config
    )
    .then((res) => {
      putResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        putResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return putResponse;
};

export const getRecording = async (baseUrl, token, meetingId) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let getResponse = null;

  await axios
    .get(baseUrl + "/meeting/meeting/record/" + meetingId, config)
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};
